import { get } from 'lodash';

function getAggregateDiscount(product: ProductToCompare): any | null | undefined {
  const proposals = get(product, 'proposals.proposals', []);
  const selectedProposal = proposals.find((proposal) => get(proposal, 'selected', true));
  return get(selectedProposal, 'price.aggregateDiscount', null);
}

export { getAggregateDiscount };
